import { useState } from "react";
import { ChromePicker } from "react-color";
import closeSvg from "../../assets/close.svg";
import "./index.less";

export default function InputColor({ onChangeComplete, color, ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: color,
      }}
      {...rest}
      onClick={(e) => {
        if (!visible) {
          setVisible(true);
        }
      }}
    >
      {visible && (
        <div
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <span
            style={{
              zIndex: 999,
              position: "absolute",
              top: 0,
              left: 0,
              color: "#999",
              cursor: "pointer",
            }}
            onClick={(e) => {
              setVisible(false);
            }}
          >
            <img src={closeSvg} alt="" width={15} height={15} />
          </span>
          <ChromePicker
            color={color}
            onChangeComplete={onChangeComplete}
            className="reset"
          />
        </div>
      )}
    </div>
  );
}
